import { EVENTS } from "../../../js/constants";
import { animateNumber } from "../../../js/utils/helper/helper";

class Progress {
  /**
   * @param {HTMLElement} element - the progress statistic element
   */
  constructor(element) {
    this.element = element;

    this.config = {
      selectors: {
        countCurrent: ".js-Progress-item--countCurrent",
        countPercentage: ".js-Progress-item--countPercentage",
        counterTarget: ".js-Progress-item--countTarget",
        progressBar: ".js-Progress-progressBar",
      },
      classes: {
        progressBar: "js-Progress-progressBar",
      },
      parameters: {
        speed: 1000,
      },
      attributes: {
        id: "data-id",
      },
    };

    this.countPercentage = element.querySelector(
      this.config.selectors.countPercentage
    );
    this.countCurrent = element.querySelector(
      this.config.selectors.countCurrent
    );
    this.countTarget = element.querySelector(
      this.config.selectors.counterTarget
    );
    this.progressBar = element.querySelector(this.config.selectors.progressBar);

    this.endpointUrl = this.element.dataset.counterStateEndpoint;

    this.values = new Map();

    this.isVisible = false;
    this.isAnimated = false;

    this._onVisibilityChange = this._onVisibilityChange.bind(this);

    this._init();
  }

  /**
   * init
   *
   * @private
   */
  async _init() {
    this._bindEventListener();

    const values = await this._fetchData();

    if (values) {
      this._saveValues(values);

      // Trigger _runAnimation in case if element is already visible

      this._runAnimation();
    }
  }

  /**
   * gets progress values from api
   *
   * @returns {object} values
   */
  async _fetchData() {
    const formData = {
      limited_webform: this.element.dataset.limitedWebform,
      limited_webform_page: this.element.dataset.limitedWebformPage,
      counter_rule_id: this.element.dataset.counterRuleId,
    };

    return (
      fetch(this.endpointUrl, {
        method: "POST",
        body: JSON.stringify(formData),
      })
        .then((res) => res.json())
        // eslint-disable-next-line no-console
        .catch((error) => console.log(error))
    );
  }

  /**
   * saves the original values of the elements which are going to be animated
   *
   * @param {object} values
   */
  _saveValues(values) {
    this.values.set(this.countCurrent, values.current_state);
    this.values.set(
      this.countPercentage,
      (values.current_state / this.countTarget.innerHTML) * 100
    );
    this.values.set(
      this.progressBar,
      (values.current_state / this.countTarget.innerHTML) * 100
    );
  }

  /**
   * binds event listener
   */
  _bindEventListener() {
    this.element.addEventListener(EVENTS.VISIBLE, this._onVisibilityChange);
  }

  /**
   * handles Visibility Change
   */
  _onVisibilityChange() {
    this.isVisible = true;
    this._runAnimation();
  }

  /**
   * runs animation when it's visible, not animated yet and when fetched data is available,
   * we need `isVisible` and `isAnimated` since it can be a race condition and the element can be visible,
   * but the data is not fetched yet.
   */
  _runAnimation() {
    if (this.isAnimated || !this.isVisible || !this.values.size) return;

    this.values.forEach((value, element) => {
      const isProgressbar = element.classList.contains(
        this.config.classes.progressBar
      );

      animateNumber(
        element,
        value,
        this.config.parameters.speed,
        isProgressbar ? "value" : "innerHTML"
      );
    });
    this.isAnimated = true;
  }
}

export default Progress;
